module.exports = __webpack_public_path__ + "img/xuanfu.ce3b01f5.png";